import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { basename } from '../locale'

const SITE = 'https://mimac.it'
const DEFAULT_IMAGE = SITE + '/img/logo.png'

// Plain text from CMS HTML, cut to a length that fits a search result snippet
export function toDescription(html, maxLength = 155) {
    if (!html) return ''
    // Space before each tag, so paragraphs don't run into each other
    const text = new DOMParser().parseFromString(html.replace(/</g, ' <'), 'text/html').body.textContent.replace(/\s+/g, ' ').trim()
    if (text.length <= maxLength) return text
    return text.slice(0, text.lastIndexOf(' ', maxLength)) + '…'
}

export function Seo({ title, description, image, type = 'website', noindex = false }) {
    const { i18n } = useTranslation()
    const { pathname } = useLocation()
    // Language versions point to each other via hreflang in sitemap.xml (scripts/prerender.js)
    const url = SITE + basename + (pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/')
    return (
        <Helmet>
            <html lang={i18n.resolvedLanguage || 'de'} />
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            {noindex ? <meta name="robots" content="noindex" /> : <link rel="canonical" href={url} />}
            <meta property="og:site_name" content="Mimac" />
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            {title && <meta property="og:title" content={title} />}
            {description && <meta property="og:description" content={description} />}
            <meta property="og:image" content={image || DEFAULT_IMAGE} />
        </Helmet>
    )
}
